import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from "vue";
import { LineTypeCode, LineTypeName } from "@/types";
import { IEarlyDriveData } from "@/domain/entities/lineInfo";


const __default__ = {
  name: "LineTypeChip",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineTypeCode: {
    type: String as PropType<LineTypeCode>,
    required: true,
  },
  lineTypeName: {
    type: String as PropType<LineTypeName>,
    required: true,
  },
  earlyDriveInfosList: {
    type: Array as PropType<IEarlyDriveData[][]>,
    default: () => [],
  },
  isSmallSize: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const driveDatesDisplayText = computed(() => {
  // 회차가 없으면 빈 문자열 반환
  if (props.earlyDriveInfosList.length === 0) return "";

  // 요일 순서를 보장하기 위한 배열 (월 ~ 일)
  const weekDays = ["월", "화", "수", "목", "금", "토", "일"];

  // 각 회차별 운행 요일 텍스트 계산
  const roundTexts = props.earlyDriveInfosList
    .map((round) => {
      // 각 회차 내에서 중복 없이 요일 이름 추출 (빈 값은 제외)
      const daysSet = new Set<string>();
      round.forEach((item) => {
        if (item.weekdayName && item.weekdayName.trim() !== "") {
          daysSet.add(item.weekdayName);
        }
      });

      // 요일을 weekDays 순서대로 정렬
      const sortedDays = weekDays.filter((day) => daysSet.has(day));

      // 회차가 월~금 모두 있는 경우 '평일'로 표시
      if (
        sortedDays.length === 5 &&
        weekDays.slice(0, 5).every((day) => daysSet.has(day))
      ) {
        return "평일";
      }

      // 회차가 월~일 모두 있는 경우 '전체'로 표시
      if (
        sortedDays.length === 7 &&
        weekDays.every((day) => daysSet.has(day))
      ) {
        return "전체";
      }

      // 그 외의 경우에는 요일 이름을 콤마로 구분하여 반환
      return sortedDays.join(", ");
    })
    .filter((text) => text.length > 0); // 빈 문자열 제거

  // 여러 회차에서 같은 결과가 나오면 중복 제거 (순서 유지)
  const uniqueRoundTexts = Array.from(new Set(roundTexts));

  // 회차 간 결과는 "/" 로 구분하여 표시
  return uniqueRoundTexts.join(" / ");
});

const __returned__ = { props, driveDatesDisplayText, get LineTypeCode() { return LineTypeCode } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})